import {config as numberColumnConfig} from '../../../common/NumberColumn';

export const prop = 'riskTotal';

export const config = (labels) =>
	numberColumnConfig({
		id: 'totalRisks',
		label: labels.totalRisks,
		prop,
		width: 'minmax(var(--px-140), 1fr)'
	});
